<template>
  <!-- 外发跟踪-->
  <div class="container">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="clickReturnList"
        >返回列表</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存录入</el-button
      >
    </div>
    <div class="contentInner" :style="'height:' + tableHeigth + 'px'">
      <!-- 左边 -->
      <div class="rightInner">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in TrackList"
            :key="index"
            :timestamp="item.title"
            placement="top"
            :color="item.color"
          >
            <el-card>
              <div class="card_class">
                <div class="line_cont">
                  <aside>{{ item.content }}</aside>
                  <div class="displayFlex">
                    <div v-if="item.expandFieldOne">
                      车牌号：{{ item.expandFieldOne || "" }}。
                    </div>
                    <div v-if="item.expandFieldTwo">
                      发出仓库：{{ item.expandFieldTwo || "" }}，
                    </div>
                    <div v-if="item.expandFieldThree">
                      目的地：{{ item.expandFieldThree || "" }}
                    </div>
                  </div>
                  <div class="trackImgsList">
                    <el-image
                      v-for="(itemA, idxA) in item.fileVoList"
                      :key="idxA"
                      class="trackImgs"
                      :src="itemA.fileUrl"
                      :preview-src-list="item.imgsList"
                    ></el-image>
                  </div>
                  <!-- <section>{{ item.createTime }}</section> -->
                  <section>{{ item.happenTime }}</section>
                </div>
                <el-switch
                  v-model="item.isShow"
                  @change="changeisShow(item)"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <!-- 右边 -->
      <div class="leftInner">
        <div style="margin-bottom: 16px">{{ outboundCarrierName }}</div>
        <el-tabs v-model="activeName" type="card" stretch>
          <el-tab-pane label="提货" name="已提货"></el-tab-pane>
          <el-tab-pane label="发车" name="已发车"></el-tab-pane>
          <el-tab-pane label="到车" name="已到车"></el-tab-pane>
          <el-tab-pane label="转运" name="已转运"></el-tab-pane>
          <el-tab-pane label="送货" name="已送货"></el-tab-pane>
          <el-tab-pane label="签收" name="签收"></el-tab-pane>
        </el-tabs>
        <div class="infoDiv" v-if="activeName == '签收'">
          <div class="formbox">
            <el-form label-width="100px" class="glo_formBox" :rules="rules">
              <div style="width: 100%" class="glo_disflex">
                <div style="margin-right: 20px; margin-bottom: 18px">
                  <el-checkbox
                    style="height: 30px; line-height: 30px"
                    v-model="isReceiveUserSign"
                    label="isReceiveUserSign"
                    name="type"
                    >默认收货人为签收人</el-checkbox
                  >
                </div>
                <el-form-item label="签收人:" prop v-if="!isReceiveUserSign">
                  <el-input
                    v-model="baseInForm.signForName"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item label="签收时间:" prop="signForTime">
                <el-date-picker
                  v-model="baseInForm.signForTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="签收情况:" prop="signForSituation">
                <el-select
                  v-model="baseInForm.signForSituation"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in signForSituationList"
                    :key="index"
                    :label="item.showName"
                    :value="item.statusVal"
                  ></el-option>
                </el-select>
              </el-form-item>
              <div style="width: 100%; display: flex; margin-bottom: 16px">
                <el-checkbox
                  v-model="isSenderSms"
                  label="isSenderSms"
                  name="sendFa"
                  >发送手机信息给发货人</el-checkbox
                >
                <el-checkbox
                  v-model="isReceiverSms"
                  label="isReceiverSms"
                  name="sendShou"
                  >发送手机信息给收货人</el-checkbox
                >
              </div>

              <!-- <el-form-item label="身份证号:">
                <el-input v-model="baseInForm.receiverIdcardNumber" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="身份证号:">
                <el-input v-model="baseInForm.agentIdcardNumber" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="手机号:">
                <el-input v-model="baseInForm.agentPhone" placeholder="请输入" clearable></el-input>
              </el-form-item> -->
              <el-form-item
                class="textArea"
                style="width: 100%"
                label="备注:"
                required
              >
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="baseInForm.remarks"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="infoDiv">
              <div style="margin-bottom: 10px">签收图片:</div>
              <uploadimgs
                @input="changeFileList1"
                :fileNameLists="fileNameLists1"
                :limit="15"
              ></uploadimgs>
            </div>
          </div>
        </div>
        <div class="infoDiv" v-else>
          <div class="formbox">
            <el-form label-width="100px" class="glo_formBox">
              <el-form-item label="发生时间:" required>
                <el-date-picker
                  v-model="addReqs.happenTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="车牌号码:">
                <el-input
                  v-model="addReqs.expandFieldOne"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="
                  activeName == '已转运' ||
                  activeName == '已发车' ||
                  activeName == '已到车'
                "
                :label="activeName == '已到车' ? '到车仓库:' : '发出仓库:'"
              >
                <el-select
                  v-model="addReqs.expandFieldTwo"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in CarrierDeptListList"
                    :key="index"
                    :label="item.deptName"
                    :value="item.carrierDeptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="目的地:" v-if="activeName == '已转运'">
                <el-input
                  v-model="addReqs.expandFieldThree"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                class="textArea"
                style="width: 100%"
                label="跟踪信息:"
                required
              >
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="addReqs.content"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="infoDiv">
              <div style="margin-bottom: 10px">图片:</div>
              <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="9"
              ></uploadimgs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: { uploadimgs },
  data() {
    return {
      tableHeigth: "75vh", //  表格高度
      activeName: "已提货",
      outboundCarrierName: "",
      CarrierDeptListList: [], //网点
      fileNameLists: [], //上传组件的
      addReqs: {
        documentStatus: "bill_tms_waybill_outgoing_v3:document_status",
        content: "",
        documentNumber: "",
        expandFieldOne: "",
        expandFieldThree: "",
        expandFieldTwo: "",
        fileIds: "",
        title: "",
        happenTime: "",
      },
      TrackList: [],
      baseInForm: {
        signForName: "",
        signForTime: "",
        signForSituation: "",
        isReceiveUserSign: "0",
        isReceiverSms: "0",
        isSenderSms: "0",
        signForFileIds: [],
        receiverIdcardNumber: "",
        agentIdcardNumber: "",
        agentPhone: "",
        remarks: "",
      },
      rules: {
        signForName: [{ required: true, message: "请输入", trigger: "blur" }],
        signForTime: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        signForSituation: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      signForSituationList: [],
      isReceiveUserSign: true,
      isSenderSms: true,
      isReceiverSms: true,
      fileNameLists1: [],
      outgoingId: "",
    };
  },
  watch: {},
  created() {
    // 获取签收情况下拉列表
    this.$TOOLS
      .getStatusValList("bill_tms_waybill_sign_for_v3.sign_for_situation")
      .then((res) => {
        this.signForSituationList = res || [];
        if (this.signForSituationList.length > 0) {
          //默认正常签收
          this.baseInForm.signForSituation = "zheng_chang:sign_for_situation";
        }
      });
  },
  mounted() {},
  activated() {
    let outgoingId = this.$route.query.outgoingId || "";
    if (outgoingId) {
      this.outgoingId = outgoingId;
    }
    this.init();
  },
  destroyed() {},
  methods: {
    changeisShow({ isShow, trackTransportId }) {
      this.$API
        .updateTrackTransportShow({
          isShow: isShow ? 1 : 0,
          trackTransportIds: [trackTransportId],
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.getData();
        });
    },
    init() {
      this.fetTableHeight();
      let { outboundCarrierId, outboundCarrierName, number } =
        this.$route.query || {};
      this.addReqs.documentNumber = number || "";
      this.outboundCarrierName = outboundCarrierName || "";
      if (outboundCarrierId) {
        this.$COMAPI.CarrierDeptList(outboundCarrierId).then((res) => {
          this.CarrierDeptListList = res || [];
        });
      }
      if (number) {
        this.$API
          .getTrackTransportList({
            documentNumber: number,
            documentStatus: "bill_tms_waybill_outgoing_v3:document_status",
          })
          .then((res) => {
            let arrs = res.data.result || [];
            let TrackList = arrs.reverse(); //翻转数组
            TrackList.forEach((item, index) => {
              item.isShow = item.isShow == 1 ? true : false;
              item.color = "";
              if (index == 0) {
                item.color = "#0bbd87";
              }
              item.imgsList = [];
              if (item.fileVoList && item.fileVoList.length > 0) {
                item.fileVoList.forEach((itemA) => {
                  item.imgsList.push(itemA.fileUrl);
                });
              }
            });

            this.TrackList = TrackList;
          });
      }
    },
    submit() {
      if (this.activeName == "签收") {
        let fids = [];
        this.fileNameLists1.forEach((item) => {
          fids.push(item.name);
        });
        this.baseInForm.signForFileIds = fids;
        this.baseInForm.isReceiveUserSign = this.isReceiveUserSign ? 1 : 0;
        this.baseInForm.isSenderSms = this.isSenderSms ? 1 : 0;
        this.baseInForm.isReceiverSms = this.isReceiverSms ? 1 : 0;
        this.baseInForm.outgoingIds =
          (this.outgoingId && [this.outgoingId]) || [];
        this.$API.signforOutgoingWaybill(this.baseInForm).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.clickReturnList();
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      } else {
        let fids = [];
        this.fileNameLists.forEach((item) => {
          fids.push(item.name);
        });
        this.addReqs.fileIds = fids;
        this.addReqs.title = this.activeName;
        if (!this.addReqs.happenTime) {
          this.$message.error("请选择发生时间");
          return false;
        }
        this.$API.addTrackTransport(this.addReqs).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.clickReturnList();
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      }
    },
    clickReturnList() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/OutgoingManage/OutgoingManage",
        query: {
          isreload: "isreload",
        },
      });
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList1(array) {
      this.fileNameLists1 = array;
    },
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //
      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
      });
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin: 0 30px;
  height: 50px;
}

.contentInner {
  width: 100%;
  display: flex;

  .rightInner {
    flex: 1;
    margin-right: 16px;
    cursor: pointer;
    overflow-y: auto;
  }

  .leftInner {
    flex: 1;
    /deep/ .el-tabs__item {
      height: 36px;
      line-height: 36px;
      background-color: #f4f4f4;
    }

    /deep/ .el-tabs__content {
      padding: 16px;
    }

    /deep/ .el-descriptions {
      margin-bottom: 10px;
    }
  }
}
.card_class {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

/deep/.el-timeline-item__timestamp {
  font-size: 16px;
  color: #333;
}
.line_cont {
  color: #888;
}
// 查询条件边框线
.infoDiv {
  margin-bottom: 20px;

  .formbox {
    padding: 0 30px;
  }
}
.textArea {
  height: 100%;
}

.displayFlex {
  display: flex;
}

.trackImgsList {
  display: flex;
  flex-wrap: wrap;

  .trackImgs {
    width: 60px;
    height: 60px;
    margin: 10px;
  }
}
</style>